// @ts-nocheck

document.addEventListener("DOMContentLoaded", function () {
  
  function toggleClasses($element, remove, add) {
    $element.removeClass(remove).addClass(add);
  }

  function setAvailabilityStyles($element, isOutOfStock) {
    if (isOutOfStock) {
      $element.css({ cursor: "not-allowed", "pointer-events": "none" });
      $element.find("span").not(".out-of-stock-message").css({ opacity: "0.5", filter: "grayscale(50%)" });
      $element.find(".lens-color-price, .lens-polarized-price, .prescription-type-price").css({ opacity: "0.5", filter: "grayscale(50%)" });
    } else {
      $element.css({ cursor: "pointer", "pointer-events": "auto" });
      $element.find("span").not(".out-of-stock-message").css({ opacity: "1", filter: "none" });
      $element.find(".lens-color-price, .lens-polarized-price, .prescription-type-price").css({ opacity: "1", filter: "none" });
    }
  }

  function getUpgradeDisplayText(upgradeText) {
    const text = upgradeText.toLowerCase();
    if (text.includes("high index") && text.includes("polarized")) return "High Index + Polarized Lenses";
    if (text.includes("high index") && text.includes("blue light")) return "High Index + Blue Light Lenses";
    if (text.includes("polarized") && text.includes("blue light")) return "Polarized + Blue Light Lenses";
    if (text.includes("polarized")) return "Polarized Lenses";
    if (text.includes("high index")) return "High Index Lenses";
    if (text.includes("blue light")) return "Blue Light Lenses";
    return upgradeText;
  }
  
  function updateSubtotalComparePrice() {
    const currentStep = parseInt($(".build-rx-step-wrap").attr("data-build-rx-step"));
    const compareAtPrice = calculateTotalCompareAtPrice(currentStep);
    if (compareAtPrice) {
      $(".subtotal-compare-price").text(compareAtPrice).show();
    } else {
      $(".subtotal-compare-price").text("").hide();
    }
  }
  
  function hideBuildRXModal() {
    toggleClasses($(".build-rx-modal"), "", "hidden");
    toggleClasses($(".build-rx-modal .modal-bg"), "opacity-100", "opacity-0");
    toggleClasses($(".build-rx-modal .modal-container"), "opacity-100 translate-y-0", "opacity-0 translate-y-4");
  }

  function showBuildRXModal() {
    toggleClasses($(".build-rx-modal"), "hidden", "");
    toggleClasses($(".build-rx-modal .modal-bg"), "opacity-0", "opacity-100");
    toggleClasses($(".build-rx-modal .modal-container"), "opacity-0 translate-y-4", "opacity-100 translate-y-0");
    setTimeout(enableAllSelections, 50);
  }

  function enableAllSelections() {
    checkPrescriptionTypeAvailability();
    checkLensColorAvailability();
    checkPolarizedLensAvailability();
    restoreLensUpgradeSelections();
  }
  
  function initializeUpgradeVisibility() {
    $(".polarized-lense-box").addClass("hidden");
    $(".no-upgrades-available").removeClass("hidden");
  }
  
  function restoreLensUpgradeSelections() {
    $(".polarized-lense-box.selected").each(function() {
      toggleClasses($(this), "border-[#DEE2E9] border", "border-[#024ED4] border-[2px] selected");
    });
  }
  
  function checkPrescriptionTypeAvailability() {
    $(".prescription-type-box").each(function() {
      const $box = $(this);
      const isOutOfStock = $box.attr("data-available") === "false" || $box.find(".out-of-stock-message").length > 0;
      setAvailabilityStyles($box, isOutOfStock);
    });
  }

  function checkLensColorAvailability() {
    $(".lens-color-item").each(function() {
      const $item = $(this);
      const $priceElement = $item.find(".lens-color-price");
      const isOutOfStock = $priceElement.attr("data-available") === "false" || $item.find(".out-of-stock-message").length > 0;
      setAvailabilityStyles($item, isOutOfStock);
    });
  }

  function checkPolarizedLensAvailability() {
    $(".polarized-lense-box").each(function() {
      const $box = $(this);
      const selectedLensColor = $box.attr("data-selected-lens-color");
      
      if (!selectedLensColor) {
        $box.addClass("hidden");
        return;
      }
      
      const $priceElement = $box.find(`.lens-polarized-price[data-lens-color="${selectedLensColor}"]`);
      
      if ($priceElement.length === 0) {
        $box.addClass("hidden");
        return;
      }
      
      $box.removeClass("hidden");
      const isOutOfStock = $priceElement.attr("data-available") === "false" || $box.find(".out-of-stock-message").length > 0;
      
      setAvailabilityStyles($box, isOutOfStock);
      
      if (isOutOfStock && !$box.find(".out-of-stock-message").length) {
        $box.find(".flex.flex-col.gap-2\\.5").append('<p class="text-[14px] leading-4 text-[#EB0D11] font-bold out-of-stock-message mt-2">This item is out of stock</p>');
      } else if (!isOutOfStock) {
        $box.find(".out-of-stock-message").remove();
      }
    });
    
    const visibleUpgrades = $(".lens-polarized-box.flex .polarized-lense-box").not(".hidden");
    $(".no-upgrades-available").toggleClass("hidden", visibleUpgrades.length > 0);
    
    if (parseInt($(".build-rx-step-wrap").attr("data-build-rx-step")) === 3) {
      $(".build-rx-continue-btn").prop("disabled", false);
    }
  }

  function resetModal() {
    $(".build-rx-step-wrap").attr("data-build-rx-step", "1");
    $(".first-step, .second-step, .third-step, .fourth-step").addClass("hidden");
    $(".first-step").removeClass("hidden");
    
    setupStepNavigation(false);
    
    toggleClasses($("#new_rx-continue-btn"), "hidden", "block");
    toggleClasses($("#new_rx_add_to_cart_form"), "block", "hidden");

    toggleClasses($(".prescription-type-box"), "border-[#024ED4] border-2 selected", "border-[#DEE2E9]");
    toggleClasses($(".lens-color-item"), "border-[#024ED4] selected border-2", "border-[#DEE2E9]");
    toggleClasses($(".polarized-lense-box"), "border-[#024ED4] border-[2px] selected", "border-[#DEE2E9] border");
    toggleClasses($(".lens-color-box, .lens-polarized-box"), "flex selected", "hidden");
    toggleClasses($(".summary-lens-polarized-wrap"), "flex", "hidden");
    
    $(".summary-lens-color-price, .summary-lens-color-title").text("");
    $(".summary-lens-polarized-price, .summary-lens-polarized-title").text("");
    $(`.variant-image`).addClass("hidden");
    $(`.variant-image[data-variant-image-no="1"]`).removeClass("hidden");
    
    initializeUpgradeVisibility();
    enableAllSelections();
    updateProgressBar(1);
  }

  function autoSelectFirstPrescriptionType() {
    const $firstAvailable = $(".prescription-type-box").filter(function() {
      return $(this).attr("data-available") !== "false" && !$(this).find(".out-of-stock-message").length;
    }).first();
    
    if ($firstAvailable.length) {
      toggleClasses($firstAvailable, "border-[#DEE2E9]", "border-[#024ED4] border-2 selected");
      
      const selectedType = $firstAvailable.attr("data-prescription-type");
      $(`.lens-color-box[data-prescription-type="${selectedType}"], .lens-polarized-box[data-prescription-type="${selectedType}"]`)
        .removeClass("hidden").addClass("flex selected");
      
      const subTotalPrice = $firstAvailable.attr("data-subtotal-price");
      const compareAtPrice = $firstAvailable.attr("data-compare-at-price");
      const prescriptionTypeText = $firstAvailable.find("span").first().text();
      const isProgressive = selectedType === 'progressive';
      
      if (subTotalPrice) $(".subtotal-price").text(subTotalPrice);
      
      $(".summary-prescription-type-title").text(prescriptionTypeText);
      if (subTotalPrice) {
        const displayPrice = '+' + subTotalPrice;
        $(".summary-prescription-type-price").text(displayPrice);
        
        if (compareAtPrice) {
          const displayComparePrice = '+' + compareAtPrice;
          $(".summary-prescription-type-compare").text(displayComparePrice).show();
        } else {
          $(".summary-prescription-type-compare").text("").hide();
        }
      }
      
      $(".build-rx-continue-btn").prop("disabled", false);
    } else {
      $(".build-rx-continue-btn").prop("disabled", true);
    }
  }

  $("#build-your-rx-btn").click(() => {
    showBuildRXModal();
    resetModal();
    autoSelectFirstPrescriptionType();
    updateSubtotal(1);
  });

  $(".build-modal-close-btn").click(() => {
    hideBuildRXModal();
    $(".variant-image").addClass("hidden");
  });
  $(window).click(function (event) {
    if ($(event.target).is(".modal-bg")) {
      hideBuildRXModal();
    }
  });

  function clearFutureStepSelections(currentStep) {
    
    if (currentStep <= 1) {
      toggleClasses($(".lens-color-item"), "border-[#024ED4] selected border-2", "border-[#DEE2E9]");
      $(".summary-lens-color-wrap").removeClass("flex").addClass("hidden");
      $(".summary-lens-color-price, .summary-lens-color-title").text("");
      $(".summary-lens-color-compare").text("").hide();
      
      toggleClasses($(".polarized-lense-box"), "border-[#024ED4] border-[2px] selected", "border-[#DEE2E9] border");
      $(".summary-lens-polarized-wrap").removeClass("flex").addClass("hidden");
      $(".summary-lens-polarized-price, .summary-lens-polarized-title").text("");
      $(".summary-lens-polarized-compare").text("").hide();
    } else if (currentStep === 2) {
      toggleClasses($(".polarized-lense-box"), "border-[#024ED4] border-[2px] selected", "border-[#DEE2E9] border");
      $(".summary-lens-polarized-wrap").removeClass("flex").addClass("hidden");
      $(".summary-lens-polarized-price, .summary-lens-polarized-title").text("");
      $(".summary-lens-polarized-compare").text("").hide();
    }
  }

  function navigateToStep(targetStep) {
    if (targetStep < 1 || targetStep > 4) return;
    
    clearFutureStepSelections(targetStep);
    
    $(".build-rx-step-wrap").attr("data-build-rx-step", targetStep);
    $(".first-step, .second-step, .third-step, .fourth-step").addClass("hidden");
    
    updateBuildingStep(targetStep);
    updateProgressBar(targetStep);
    updateSubtotal(targetStep);
    
    setTimeout(() => enableAllSelections(), 10);
    
    if (targetStep < 4) {
      toggleClasses($("#new_rx-continue-btn"), "hidden", "block");
      toggleClasses($("#new_rx_add_to_cart_form"), "block", "hidden");
    } else {
      toggleClasses($("#new_rx-continue-btn"), "block", "hidden");
      toggleClasses($("#new_rx_add_to_cart_form"), "hidden", "block");
      setTimeout(() => updateAddToCartButton(), 10);
    }
  }

  $(".build-rx-continue-btn").click(function () {
    const currentStep = parseInt($(".build-rx-step-wrap").attr("data-build-rx-step"));
    const nextStep = currentStep + 1;
    if (nextStep <= 4) navigateToStep(nextStep);
  });

  $(".build-modal-back-btn").click(() => {
    const currentStep = parseInt($(".build-rx-step-wrap").attr("data-build-rx-step"));
    const prevStep = Math.max(1, currentStep - 1);
    navigateToStep(prevStep);
  });

  function setupStepNavigation(showBackButton) {
    const $backBtn = $(".build-modal-back-btn");
    const $iconWrap = $(".modal-icon-wrap");
    
    if (showBackButton) {
      $backBtn.removeClass("hidden");
      $iconWrap.removeClass("justify-end").addClass("justify-between");
    } else {
      $backBtn.addClass("hidden");
      $iconWrap.removeClass("justify-between").addClass("justify-end");
    }
  }

  function updateBuildingStep(step) {
    const isReviewStep = step === 4;
    
    if (!isReviewStep) enableAllSelections();

    if (step === 1) {
      $(".first-step").removeClass("hidden");
      setupStepNavigation(false);
      
      toggleClasses($(".summary-lens-color-wrap"), "flex", "hidden");
      toggleClasses($(".summary-lens-polarized-wrap"), "flex", "hidden");
      
      // Enable/disable summary button based on prescription type selection
      const selectedPrescriptionType = $(".prescription-type-box.selected");
      if (selectedPrescriptionType.length) {
        $(".summary-drop-down-btn").prop("disabled", false);
      } else {
        $(".summary-drop-down-btn").prop("disabled", true);
      }
      
      checkPrescriptionTypeAvailability();
      
    } else if (step === 2) {
      $(".second-step").removeClass("hidden");
      setupStepNavigation(true);
      
      let selectedLensColorItem = $(".lens-color-item.selected");
      if (!selectedLensColorItem.length) {
        const $firstAvailableLensColor = $(".lens-color-box.flex.selected").find(".lens-color-item").filter(function() {
          const $priceElement = $(this).find(".lens-color-price");
          return $priceElement.attr("data-available") !== "false" && !$(this).find(".out-of-stock-message").length;
        }).first();
        
        if ($firstAvailableLensColor.length) {
          toggleClasses($firstAvailableLensColor, "border-[#DEE2E9]", "border-[#024ED4] selected border-2");
          
          const selectedLensColorNo = $firstAvailableLensColor.attr("data-lens-color-no");
          const selectedColor = $firstAvailableLensColor.attr("data-lens-color");
          const $priceElement = $firstAvailableLensColor.find(".lens-color-price");
          
          $(".variant-image").addClass("hidden");
          $(`.variant-image[data-variant-image-no="${selectedLensColorNo}"]`).removeClass("hidden");
          
          const subTotalPrice = $priceElement.attr("data-subtotal-price");
          const summaryPrice = $priceElement.attr("data-summary-price");
          const variantId = $priceElement.attr("data-variant-id");
          
          if (subTotalPrice) $(".subtotal-price").text(subTotalPrice);
          if (summaryPrice) {
            $(".summary-lens-color-wrap").removeClass("hidden").addClass("flex");
            $(".summary-lens-color-title").text(`${selectedColor} Lens`);
            
            if (summaryPrice === "FREE") {
              $(".summary-lens-color-price").text("FREE");
              $(".summary-lens-color-compare").text("").hide();
            } else {
              // Check if there's compare_at_price in the HTML
              const $inlineFlexSpan = $priceElement.find('span.inline-flex');
              
              if ($inlineFlexSpan.length > 0) {
                const currentPrice = $inlineFlexSpan.find('span').not('.line-through').first().text().trim();
                const compareAtPrice = $inlineFlexSpan.find('span.line-through').text().trim();
                
                $(".summary-lens-color-price").text(currentPrice);
                $(".summary-lens-color-compare").text(compareAtPrice).show();
              } else {
                $(".summary-lens-color-price").text(summaryPrice);
                $(".summary-lens-color-compare").text("").hide();
              }
            }
          }
          
          $(".polarized-lense-box").attr("data-selected-lens-color", selectedColor);
          toggleClasses($(".lens-polarized-price"), "block", "hidden");
          $(`.lens-polarized-price[data-lens-color="${selectedColor}"]`).removeClass("hidden").addClass("block");
          checkPolarizedLensAvailability();
          
          $("#new_rx_add_to_cart_form").find("input[name='id']").val(variantId).end()
            .find("button").attr("cc-compare-flow", variantId);
          selectedLensColorItem = $firstAvailableLensColor;
        }
      }
      
      if (selectedLensColorItem.length) {
        // Ensure lens color is shown in summary and populate it
        const selectedColor = selectedLensColorItem.attr("data-lens-color");
        const $priceElement = selectedLensColorItem.find(".lens-color-price");
        const summaryPrice = $priceElement.attr("data-summary-price");
        
        $(".summary-lens-color-wrap").removeClass("hidden").addClass("flex");
        $(".summary-lens-color-title").text(`${selectedColor} Lens`);
        
        if (summaryPrice === "FREE") {
          $(".summary-lens-color-price").text("FREE");
          $(".summary-lens-color-compare").text("").hide();
        } else if (summaryPrice) {
          const $inlineFlexSpan = $priceElement.find('span.inline-flex');
          
          if ($inlineFlexSpan.length > 0) {
            const currentPrice = $inlineFlexSpan.find('span').not('.line-through').first().text().trim();
            const compareAtPrice = $inlineFlexSpan.find('span.line-through').text().trim();
            
            $(".summary-lens-color-price").text(currentPrice);
            $(".summary-lens-color-compare").text(compareAtPrice).show();
          } else {
            $(".summary-lens-color-price").text(summaryPrice);
            $(".summary-lens-color-compare").text("").hide();
          }
        }
        
        $(".summary-drop-down-btn").prop("disabled", false);
      } else {
        $(".summary-drop-down-btn").prop("disabled", true);
      }
      toggleClasses($(".summary-lens-polarized-wrap"), "flex", "hidden");
      
    } else if (step === 3) {
      $(".third-step").removeClass("hidden");
      setupStepNavigation(true);
      
      toggleClasses($(".lens-polarized-box .polarized-lense-box"), "selected border-[#024ED4] border-[2px]", "border-[#DEE2E9] border");
      toggleClasses($(".summary-lens-polarized-wrap"), "flex", "hidden");
      
      const selectedLensColor = $(".lens-color-item.selected").attr("data-lens-color");
      if (selectedLensColor) $(".polarized-lense-box").attr("data-selected-lens-color", selectedLensColor);
      
      checkPolarizedLensAvailability();
      $(".build-rx-continue-btn").prop("disabled", false);
      $(".summary-drop-down-btn").prop("disabled", false);
      
    } else if (step === 4) {
      $(".fourth-step").removeClass("hidden");
      setupStepNavigation(true);
      populateReviewSelections();
      $(".summary-drop-down-btn").prop("disabled", false);
    }
    
    const compareAtPrice = calculateTotalCompareAtPrice();
    if (compareAtPrice) {
      $(".subtotal-compare-price").text(compareAtPrice).show();
    } else {
      $(".subtotal-compare-price").text("").hide();
    }
  }

  function updateProgressBar(step) {
    if(step > 4) return;
    const progressWidth = (step / 4) * 100; 
    $(".build-rx-step-wrap .current-progress-bar").css("width", `${progressWidth}%`);
  }

  function calculateTotalCompareAtPrice(currentStep) {
    let hasCompareAt = false;
    let finalCompareAt = 0;
    
    const step = currentStep || parseInt($(".build-rx-step-wrap").attr("data-build-rx-step"));
    
    if (step >= 3) {
      const selectedLensPolarizedBox = $(".lens-polarized-box.selected");
      const selectedPolarized = selectedLensPolarizedBox.find(".polarized-lense-box.selected");
      if (selectedPolarized.length) {
        const selectedLensColor = selectedPolarized.attr("data-selected-lens-color");
        if (selectedLensColor) {
          const $priceElement = selectedPolarized.find(`.lens-polarized-price[data-lens-color="${selectedLensColor}"]`);
          const polarizedCompareAt = $priceElement.attr("data-compare-at-price");
          
          if (polarizedCompareAt) {
            finalCompareAt = parseFloat(polarizedCompareAt.replace(/[^0-9.]/g, ''));
            hasCompareAt = true;
          }
        }
      }
    }
    
    if (!hasCompareAt && step >= 2) {
      const selectedLensColorBox = $(".lens-color-box.selected");
      const selectedColor = selectedLensColorBox.find(".lens-color-item.selected");
      if (selectedColor.length) {
        const $priceElement = selectedColor.find(".lens-color-price");
        const colorCompareAt = $priceElement.attr("data-compare-at-price");
        
        if (colorCompareAt) {
          finalCompareAt = parseFloat(colorCompareAt.replace(/[^0-9.]/g, ''));
          hasCompareAt = true;
        }
      }
    }
    
    if (!hasCompareAt) {
      const selectedPrescriptionType = $(".prescription-type-box.selected");
      if (selectedPrescriptionType.length) {
        const baseCompareAt = selectedPrescriptionType.attr("data-compare-at-price");
        
        if (baseCompareAt) {
          finalCompareAt = parseFloat(baseCompareAt.replace(/[^0-9.]/g, ''));
          hasCompareAt = true;
        }
      }
    }
    
    if (hasCompareAt) {
      return '$' + finalCompareAt.toFixed(0);
    }
    return "";
  }

  function updateSubtotal(step) {
    let subtotal = $(".build-rx-step-wrap .subtotal-price").text();
    const continueButton = $(".build-rx-continue-btn");

    if (step === 1) {
      const selectedPrescriptionType = $(".prescription-type-box.selected");
      if (selectedPrescriptionType.length) {
        subtotal = selectedPrescriptionType.attr("data-subtotal-price") || "0.00";
        continueButton.prop("disabled", false);
      } else {
        continueButton.prop("disabled", true);
      }
    } else if (step === 2) {
      const selectedLensColorBox = $(".lens-color-box.selected");
      const selectedColor = selectedLensColorBox.find(".lens-color-item.selected");
      if (selectedColor.length) {
        const $priceElement = selectedColor.find(".lens-color-price");
        subtotal = $priceElement.attr("data-subtotal-price") || "0.00";
        continueButton.prop("disabled", false);
      } else {
        continueButton.prop("disabled", true);
      }
    } else if (step === 3) {
      const selectedLensPolarizedBox = $(".lens-polarized-box.selected");
      const selectedPolarized = selectedLensPolarizedBox.find(".polarized-lense-box.selected");
      const selectedLensColor = selectedPolarized.attr("data-selected-lens-color");
      const noUpgradesAvailable = $(".no-upgrades-available").not(".hidden").length > 0;
      const visibleUpgrades = $(".lens-polarized-box.flex .polarized-lense-box").not(".hidden");

      if (selectedPolarized.length && selectedLensColor) {
        const $priceElement = selectedPolarized.find(`.lens-polarized-price[data-lens-color="${selectedLensColor}"]`);
        subtotal = $priceElement.attr("data-subtotal-price") || subtotal;
        continueButton.prop("disabled", false);
      } else {
        const selectedLensColorBox = $(".lens-color-box.selected");
        const selectedColor = selectedLensColorBox.find(".lens-color-item.selected");
        if (selectedColor.length) {
          const $priceElement = selectedColor.find(".lens-color-price");
          subtotal = $priceElement.attr("data-subtotal-price") || subtotal;
        }
        continueButton.prop("disabled", false);
      }
    } else if (step === 4) {
      const selectedLensPolarizedBox = $(".lens-polarized-box.selected");
      const selectedPolarized = selectedLensPolarizedBox.find(".polarized-lense-box.selected");
      const selectedLensColor = selectedPolarized.attr("data-selected-lens-color");
      
      if (selectedPolarized.length && selectedLensColor) {
        const $priceElement = selectedPolarized.find(`.lens-polarized-price[data-lens-color="${selectedLensColor}"]`);
        subtotal = $priceElement.attr("data-subtotal-price") || subtotal;
      } else {
        const selectedLensColorBox = $(".lens-color-box.selected");
        const selectedColor = selectedLensColorBox.find(".lens-color-item.selected");
        if (selectedColor.length) {
          const $priceElement = selectedColor.find(".lens-color-price");
          subtotal = $priceElement.attr("data-subtotal-price") || subtotal;
        }
      }
      continueButton.prop("disabled", false);
    }

    $(".build-rx-step-wrap .subtotal-price").text(subtotal);
    
    const compareAtPrice = calculateTotalCompareAtPrice(step);
    if (compareAtPrice) {
      $(".subtotal-compare-price").text(compareAtPrice).show();
    } else {
      $(".subtotal-compare-price").text("").hide();
    }
  }

  $(".prescription-type-box").click(function () {
    const $clicked = $(this);
    const isOutOfStock = $clicked.attr("data-available") === "false" || $clicked.find(".out-of-stock-message").length > 0;
    
    if (isOutOfStock) return false;

    const wasSelected = $clicked.hasClass("selected");
    
    if (wasSelected) {
      return;
    }
    
    enableAllSelections();
    
    toggleClasses($(".prescription-type-box"), "border-[#024ED4] border-2 selected", "border-[#DEE2E9]");
    toggleClasses($clicked, "border-[#DEE2E9]", "border-[#024ED4] border-2 selected");

    toggleClasses($(".lens-color-item"), "border-[#024ED4] selected border-2", "border-[#DEE2E9]");
    toggleClasses($(".polarized-lense-box"), "border-[#024ED4] border-[2px] selected", "border-[#DEE2E9] border");
    $(".summary-lens-color-wrap").removeClass("flex").addClass("hidden");
    $(".summary-lens-polarized-wrap").removeClass("flex").addClass("hidden");
    $(".summary-lens-color-price, .summary-lens-color-title, .summary-lens-color-compare").text("");
    $(".summary-lens-polarized-price, .summary-lens-polarized-title, .summary-lens-polarized-compare").text("");

    const selectedType = $clicked.attr("data-prescription-type");
    $(".lens-color-box, .lens-polarized-box").removeClass("flex selected").addClass("hidden");
    $(`.lens-color-box[data-prescription-type="${selectedType}"], .lens-polarized-box[data-prescription-type="${selectedType}"]`)
      .removeClass("hidden").addClass("flex selected");

    const subTotalPrice = $clicked.attr("data-subtotal-price");
    const typeCompareAtPrice = $clicked.attr("data-compare-at-price");
    const prescriptionTypeText = $clicked.find("span").first().text();
    const isProgressive = selectedType === 'progressive';
    
    if (subTotalPrice) $(".subtotal-price").text(subTotalPrice);
    
    $(".summary-prescription-type-title").text(prescriptionTypeText);
    if (subTotalPrice) {
      // Add '+' symbol before prescription type price in summary
      const displayPrice = '+' + subTotalPrice;
      $(".summary-prescription-type-price").text(displayPrice);
      
      if (typeCompareAtPrice) {
        const displayComparePrice = '+' + typeCompareAtPrice;
        $(".summary-prescription-type-compare").text(displayComparePrice).show();
      } else {
        $(".summary-prescription-type-compare").text("").hide();
      }
    }
    
    updateSubtotalComparePrice();
    
    $(".build-rx-continue-btn").prop("disabled", !selectedType);
  });

  $(".lens-color-item").click(function () {
    const $clicked = $(this);
    const wasSelected = $clicked.hasClass("selected");
    
    if (wasSelected) {
      return;
    }
    
    enableAllSelections();
    
    toggleClasses($(".lens-color-item"), "border-[#024ED4] selected border-2", "border-[#DEE2E9]");
    toggleClasses($clicked, "border-[#DEE2E9]", "border-[#024ED4] selected border-2");

    const selectedLensColorNo = $clicked.attr("data-lens-color-no");
    const selectedColor = $clicked.attr("data-lens-color");
    const $priceElement = $clicked.find(".lens-color-price");
    
    $(".variant-image").addClass("hidden");
    $(`.variant-image[data-variant-image-no="${selectedLensColorNo}"]`).removeClass("hidden");

    const subTotalPrice = $priceElement.attr("data-subtotal-price");
    const summaryPrice = $priceElement.attr("data-summary-price");
    
    if (subTotalPrice) $(".subtotal-price").text(subTotalPrice);
    if (summaryPrice) {
      $(".summary-lens-color-wrap").removeClass("hidden").addClass("flex");
      $(".summary-lens-color-title").text(`${selectedColor} Lens`);
      
      if (summaryPrice === "FREE") {
        $(".summary-lens-color-price").text("FREE");
        $(".summary-lens-color-compare").text("").hide();
      } else {
        // Check if there's compare_at_price in the HTML
        const $inlineFlexSpan = $priceElement.find('span.inline-flex');
        
        if ($inlineFlexSpan.length > 0) {
          const currentPrice = $inlineFlexSpan.find('span').not('.line-through').first().text().trim();
          const compareAtPrice = $inlineFlexSpan.find('span.line-through').text().trim();
          
          $(".summary-lens-color-price").text(currentPrice);
          $(".summary-lens-color-compare").text(compareAtPrice).show();
        } else {
          $(".summary-lens-color-price").text(summaryPrice);
          $(".summary-lens-color-compare").text("").hide();
        }
      }
    }

    $(".polarized-lense-box").attr("data-selected-lens-color", selectedColor);
    toggleClasses($(".lens-polarized-price"), "block", "hidden");
    $(`.lens-polarized-price[data-lens-color="${selectedColor}"]`).removeClass("hidden").addClass("block");
    
    checkPolarizedLensAvailability();
    
    const variantId = $priceElement.attr("data-variant-id");
    $("#new_rx_add_to_cart_form").find("input[name='id']").val(variantId).end()
      .find("button").attr("cc-compare-flow", variantId);
    
    // Update subtotal compare_at_price
    updateSubtotalComparePrice();
    
    $(".build-rx-continue-btn, .summary-drop-down-btn").prop("disabled", false);
  });

  $(".polarized-lense-box").click(function () {
    const $clicked = $(this);
    const wasSelected = $clicked.hasClass("selected");
    enableAllSelections();

    if (wasSelected) {
      toggleClasses($clicked, "border-[#024ED4] border-[2px] selected", "border-[#DEE2E9] border");
      toggleClasses($(".summary-lens-polarized-wrap"), "flex", "hidden");
      
      $(".summary-lens-polarized-title, .summary-lens-polarized-price, .summary-lens-polarized-compare").text("");
      
      const selectedLensColorItem = $(".lens-color-item.selected");
      const lensColorSubtotal = selectedLensColorItem.find(".lens-color-price").attr("data-subtotal-price");
      const standardVariantId = selectedLensColorItem.find(".lens-color-price").attr("data-variant-id");
      
      if (lensColorSubtotal) $(".subtotal-price").text(lensColorSubtotal);
      if (standardVariantId) {
        $("#new_rx_add_to_cart_form").find("input[name='id']").val(standardVariantId).end()
          .find("button").attr("cc-compare-flow", standardVariantId);
      }
      
      // Update subtotal compare_at_price when deselecting
      updateSubtotalComparePrice();
      
      return;
    }

    const selectedLensColor = $clicked.attr("data-selected-lens-color");
    toggleClasses($(".polarized-lense-box"), "border-[#024ED4] border-[2px] selected", "border-[#DEE2E9] border");
    toggleClasses($clicked, "border-[#DEE2E9] border", "border-[#024ED4] border-[2px] selected");

    const $priceElement = $clicked.find(`.lens-polarized-price[data-lens-color="${selectedLensColor}"]`);
    const subTotalPrice = $priceElement.attr("data-subtotal-price");
    const summaryPrice = $priceElement.attr("data-summary-price");
    const upgradeText = $clicked.find("span").first().text();
    const variantId = $priceElement.attr("data-variant-id");
    
    if (subTotalPrice) $(".subtotal-price").text(subTotalPrice);
    
    toggleClasses($(".summary-lens-polarized-wrap"), "hidden", "flex");
    if (summaryPrice) {
      $(".summary-lens-polarized-title").text(getUpgradeDisplayText(upgradeText, selectedLensColor));
      
      // Check if there's compare_at_price in the HTML
      const $inlineFlexSpan = $priceElement.find('span.inline-flex');
      
      if ($inlineFlexSpan.length > 0) {
        const currentPrice = $inlineFlexSpan.find('span').not('.line-through').first().text().trim();
        const compareAtPrice = $inlineFlexSpan.find('span.line-through').text().trim();
        
        $(".summary-lens-polarized-price").text(currentPrice);
        $(".summary-lens-polarized-compare").text(compareAtPrice).show();
      } else {
        $(".summary-lens-polarized-price").text(summaryPrice);
        $(".summary-lens-polarized-compare").text("").hide();
      }
    }
    
    $clicked.closest(".lens-polarized-box").attr("data-selected-upgrade-type", upgradeText);
    $("#new_rx_add_to_cart_form").find("input[name='id']").val(variantId).end()
      .find("button").attr("cc-compare-flow", variantId);
    
    // Update subtotal compare_at_price
    updateSubtotalComparePrice();
  });

  $(".summary-drop-down-btn").click(function () {
    $(this).toggleClass("rotate-180");
    $(".summary-contents").toggleClass("flex hidden");
  });

  function checkVariantAvailability() {
    let currentVariantId = null;
    let isAvailable = true; 

    const form = $("#new_rx_add_to_cart_form");
    currentVariantId = form.find("input[name='id']").val();

    if (currentVariantId) {
      const selectedPolarized = $(".polarized-lense-box.selected");
      const selectedLensColor = $(".lens-color-item.selected");

      if (selectedPolarized.length) {
        const selectedLensColorAttr = selectedPolarized.attr("data-selected-lens-color");
        const variantElement = selectedPolarized.find(`.lens-polarized-price[data-lens-color="${selectedLensColorAttr}"][data-variant-id="${currentVariantId}"]`);
        const availableAttr = variantElement.attr("data-available");
        isAvailable = availableAttr === undefined || availableAttr === "true";
      } else if (selectedLensColor.length) {
        const variantElement = selectedLensColor.find(`.lens-color-price[data-variant-id="${currentVariantId}"]`);
        
        if (variantElement.length) {
          const availableAttr = variantElement.attr("data-available");
          isAvailable = availableAttr === undefined || availableAttr === "true";
        } else {
          const standardVariantElement = selectedLensColor.find(`.lens-color-price`);
          const standardVariantId = standardVariantElement.attr("data-variant-id");
          const availableAttr = standardVariantElement.attr("data-available");
          isAvailable = availableAttr === undefined || availableAttr === "true";
          
          form.find("input[name='id']").val(standardVariantId);
          form.find("button").attr("cc-compare-flow", standardVariantId);
        }
      }
    }

    return isAvailable;
  }

  function updateAddToCartButton() {
    const addToCartButton = $(".build-rx-add-to-cart-btn");
    const isAvailable = checkVariantAvailability();

    if (isAvailable) {
      addToCartButton.prop("disabled", false);
      addToCartButton.text("ADD TO CART");
      addToCartButton.removeClass("opacity-50 cursor-not-allowed");
    } else {
      addToCartButton.prop("disabled", true);
      addToCartButton.text("SOLD OUT");
      addToCartButton.addClass("opacity-50 cursor-not-allowed");
    }
  }

  function populateReviewSelections() {
    const selectedPrescriptionType = $(".prescription-type-box.selected");
    if (selectedPrescriptionType.length) {
      const prescriptionTypeText = selectedPrescriptionType.find("span").first().text();
      $(".selected-lens-type").text(prescriptionTypeText);
      
      // Populate Lens Type price with compare_at_price if available
      const typeSubtotalPrice = selectedPrescriptionType.attr("data-subtotal-price");
      const typeCompareAtPrice = selectedPrescriptionType.attr("data-compare-at-price");
      const prescriptionType = selectedPrescriptionType.attr("data-prescription-type");
      
      if (typeSubtotalPrice) {
        const displayPrice = '+' + typeSubtotalPrice;
        $(".selected-lens-type-price span").eq(0).text(displayPrice);
        
        if (typeCompareAtPrice) {
          const displayComparePrice = '+' + typeCompareAtPrice;
          $(".selected-lens-type-price span").eq(1).text(displayComparePrice);
        } else {
          $(".selected-lens-type-price span").eq(1).text("");
        }
      }
    }

    const selectedLensColor = $(".lens-color-item.selected");
    if (selectedLensColor.length) {
      const colorName = selectedLensColor.find(".lens-color-title").text();
      const colorImage = selectedLensColor.find("img").attr("src");
      
      $(".selected-color-name").text(colorName);
      if (colorImage) {
        $(".selected-color-preview").css("background-image", `url(${colorImage})`);
        $(".selected-color-preview").css("background-size", "cover");
      }
      
      // Populate Lens Color price with compare_at_price if available
      const $lensColorPrice = selectedLensColor.find(".lens-color-price");
      const summaryPrice = $lensColorPrice.attr("data-summary-price");
      
      if (summaryPrice === "FREE") {
        // For FREE options, show FREE badge and hide price section
        $(".selected-lens-color-free-badge").removeClass("hidden");
        $(".selected-lens-color-price").hide();
      } else if (summaryPrice) {
        // For paid options, hide FREE badge and show price
        $(".selected-lens-color-free-badge").addClass("hidden");
        $(".selected-lens-color-price").show();
        
        // Check if there's a wrapper span with inline-flex (indicates compare_at_price exists)
        const $inlineFlexSpan = $lensColorPrice.find('span.inline-flex');
        
        if ($inlineFlexSpan.length > 0) {
          // Has compare_at_price - extract both prices from the nested structure
          const currentPrice = $inlineFlexSpan.find('span').not('.line-through').first().text().trim();
          const compareAtPrice = $inlineFlexSpan.find('span.line-through').text().trim();
          
          $(".selected-lens-color-price span").eq(0).text(currentPrice);
          $(".selected-lens-color-price span").eq(1).text(compareAtPrice);
        } else {
          // No compare_at_price - show only current price
          const displayPrice = summaryPrice.startsWith('+') ? summaryPrice : '+' + summaryPrice;
          $(".selected-lens-color-price span").eq(0).text(displayPrice);
          $(".selected-lens-color-price span").eq(1).text("");
        }
      }
    }

    const allSelectedUpgrades = $(".polarized-lense-box.selected");
    const visibleSelectedUpgrades = allSelectedUpgrades.filter(function() {
      return $(this).parent().hasClass("flex") && !$(this).hasClass("hidden");
    });
    
    const summaryUpgradeVisible = $(".summary-lens-polarized-wrap").hasClass("flex");
    const storedUpgradeText = $(".summary-lens-polarized-title").text();
    
    if (visibleSelectedUpgrades.length > 0) {
      const upgradeText = visibleSelectedUpgrades.first().find("span").first().text();
      const upgradeTextLower = upgradeText.toLowerCase();
      
      // Set upgrade text
      if(upgradeTextLower.includes("high index") && upgradeTextLower.includes("polarized"))
        $(".selected-lens-upgrade").text("High Index + Polarized Lenses");
      else if(upgradeTextLower.includes("high index") && upgradeTextLower.includes("blue light"))
        $(".selected-lens-upgrade").text("High Index + Blue Light Lenses");
      else if(upgradeTextLower.includes("polarized") && upgradeTextLower.includes("blue light"))
        $(".selected-lens-upgrade").text("Polarized + Blue Light Lenses");
      else if(upgradeTextLower.includes("polarized"))
        $(".selected-lens-upgrade").text("Polarized Lenses");
      else if (upgradeTextLower.includes("high index"))
        $(".selected-lens-upgrade").text("High Index Lenses");
      else if (upgradeTextLower.includes("blue light"))
        $(".selected-lens-upgrade").text("Blue Light Lenses");
      else {
        $(".selected-lens-upgrade").text(upgradeText);
      }
      
      // Populate upgrade price with compare_at_price if available
      const selectedLensColorAttr = visibleSelectedUpgrades.first().attr("data-selected-lens-color");
      const $upgradePrice = visibleSelectedUpgrades.first().find(`.lens-polarized-price[data-lens-color="${selectedLensColorAttr}"]`);
      
      if ($upgradePrice.length) {
        // Check if there's a wrapper span with inline-flex (indicates compare_at_price exists)
        const $inlineFlexSpan = $upgradePrice.find('span.inline-flex');
        
        if ($inlineFlexSpan.length > 0) {
          // Has compare_at_price - extract both prices from the nested structure
          const currentPrice = $inlineFlexSpan.find('span').not('.line-through').first().text().trim();
          const compareAtPrice = $inlineFlexSpan.find('span.line-through').text().trim();
          
          $(".selected-lens-upgrade-price span").eq(0).text(currentPrice);
          $(".selected-lens-upgrade-price span").eq(1).text(compareAtPrice);
        } else {
          // No compare_at_price - show only current price
          const summaryPrice = $upgradePrice.attr("data-summary-price");
          const displayPrice = summaryPrice.startsWith('+') ? summaryPrice : '+' + summaryPrice;
          $(".selected-lens-upgrade-price span").eq(0).text(displayPrice);
          $(".selected-lens-upgrade-price span").eq(1).text("");
        }
      }
    } else if (summaryUpgradeVisible && storedUpgradeText && storedUpgradeText !== "") {
      $(".selected-lens-upgrade").text(storedUpgradeText);
      
      // Try to populate price from summary
      const summaryUpgradePrice = $(".summary-lens-polarized-price").text();
      if (summaryUpgradePrice) {
        $(".selected-lens-upgrade-price span").eq(0).text(summaryUpgradePrice);
        $(".selected-lens-upgrade-price span").eq(1).text("");
      }
    } else {
      $(".selected-lens-upgrade").text("Standard");
      $(".selected-lens-upgrade-price span").eq(0).text("");
      $(".selected-lens-upgrade-price span").eq(1).text("");
      
      const selectedLensColor = $(".lens-color-item.selected");
      if (selectedLensColor.length) {
        const standardVariantId = selectedLensColor.find(".lens-color-price").attr("data-variant-id");
        const form = $("#new_rx_add_to_cart_form");
        if (standardVariantId) {
          form.find("input[name='id']").val(standardVariantId);
          form.find("button").attr("cc-compare-flow", standardVariantId);
        }
      }
    }

    const currentSubtotal = $(".subtotal-price").text();
    $(".review-total-price").text(currentSubtotal);

    updateAddToCartButton();
  }

  $(".build-rx-add-to-cart-btn").on("click", function(e) {
    e.preventDefault();
    
    hideBuildRXModal();
    $(".variant-image").addClass("hidden");
    
    const form = $("#new_rx_add_to_cart_form");
    const formData = form.serialize();
    
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: formData,
      dataType: "json",
      success: function(response) {
        setTimeout(() => {
          const cartIcon = document.querySelector('[data-cart-icon], .cart-icon, [href="/cart"], .header__icon--cart');
          if (cartIcon) {
            cartIcon.click();
          } else {
            const customEvent = new CustomEvent('cart:open');
            document.dispatchEvent(customEvent);
          }
        }, 300);
      },
      error: function(error) {
        console.error("Error adding to cart:", error);
      }
    });
  });
});
